import { render, staticRenderFns } from "./OP_PxSummary.vue?vue&type=template&id=01c9f1d6&scoped=true&"
import script from "./OP_PxSummary.vue?vue&type=script&lang=js&"
export * from "./OP_PxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9f1d6",
  null
  
)

export default component.exports